"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transformProductParamsToGroups;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

/**
 * @param {Array} groups
 * @param {function} [groupsFilter]
 * @param {function} t translate
 * @param {Array} consolidatedParams
 *
 * @returns Merged and normalized `Array` of product parameters.
 */
function transformProductParamsToGroups(groups, groupsFilter, t, consolidatedParams) {
  return [{
    code: '/',
    label: '',
    helperText: ''
  }].concat((0, _toConsumableArray2.default)(groups.map(function (i) {
    return (0, _extends2.default)({}, i, {
      helperText: i.helperText ? t(i.helperText, {
        acceptString: true
      }) : ''
    });
  }))).filter(groupsFilter || function () {
    return true;
  }).map(function (x) {
    return (0, _extends2.default)({}, x, {
      parameters: consolidatedParams.filter(function (y) {
        return y.group === x.code;
      }).map(function (y) {
        return (0, _extends2.default)({}, y, {
          helperText: y.helperText ? t(y.helperText, {
            acceptString: true
          }) : ''
        });
      })
    });
  });
}